import { MenuProps } from '@mui/material'

export const typographySx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  width: '90%!important',
  whiteSpace: 'nowrap',
  minWidth: '100%',
}

export const getValueSx = (disabled?: boolean) => ({
  padding: 0,
  cursor: disabled ? 'default' : 'pointer',

  '&:hover': { backgroundColor: 'transparent' },
})

export const getMenuProps = (
  withLabel?: boolean,
  width?: string | number,
): Partial<MenuProps> => ({
  PaperProps: {
    sx: {
      minHeight: '0!important',
      right: withLabel ? '28px' : undefined,
      ul: {
        padding: '0!important',
        maxWidth: withLabel ? (width ?? '300px') : undefined,
      },
    },
  },
})

export const getItemSx = (transparentBg?: boolean, activeValue?: boolean) => ({
  backgroundColor: transparentBg
    ? 'transparent!important'
    : activeValue
      ? '#EBF4FF!important'
      : undefined,

  '&:hover': { backgroundColor: '#EBF4FF!important' },
})
